import { render, staticRenderFns } from "./RecibosEsam.vue?vue&type=template&id=671fb1f2"
import script from "./RecibosEsam.vue?vue&type=script&lang=js"
export * from "./RecibosEsam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports